module.exports = __webpack_public_path__ + "img/sio2-logo.68424b76.jpg";